import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { BranchSettingsResponseDto } from "../../shared/dtos/branchSettings/BranchSettingsResponseDto";
import { ServerStatusPayload } from "../../shared/interfaces/ServerStatusPayload";

export interface SettingsState {
  branchSettings: BranchSettingsResponseDto | null;
  loadingBranchSettings: boolean;
  loadingUpdateBranchSettings: boolean;
  errorBranchSettings: string | null;
  errorUpdateBranchSettings: string | null;
  serverStatus: ServerStatusPayload | null;
}

const initialState: SettingsState = {
  branchSettings: null,
  loadingBranchSettings: false,
  loadingUpdateBranchSettings: false,
  errorBranchSettings: null,
  errorUpdateBranchSettings: null,
  serverStatus: null,
};

export const settingsSlice = createSlice({
  name: "settings",
  initialState,
  reducers: {
    setLoadingBranchSettings(state) {
      state.loadingBranchSettings = true;
      state.errorBranchSettings = null;
    },
    setLoadingUpdateBranchSettings(state) {
      state.loadingUpdateBranchSettings = true;
      state.errorUpdateBranchSettings = null;
    },
    setErrorBranchSettings(state, action: PayloadAction<string | null>) {
      state.loadingBranchSettings = false;
      state.errorBranchSettings = action.payload;
    },
    setErrorUpdateBranchSettings(state, action: PayloadAction<string | null>) {
      state.loadingUpdateBranchSettings = false;
      state.errorUpdateBranchSettings = action.payload;
    },
    setBranchSettings(state, action: PayloadAction<BranchSettingsResponseDto>) {
      state.loadingBranchSettings = false;
      state.branchSettings = action.payload;
      state.errorBranchSettings = null;
    },
    updateBranchSettingsSuccess(
      state,
      action: PayloadAction<BranchSettingsResponseDto>,
    ) {
      state.loadingUpdateBranchSettings = false;
      state.branchSettings = action.payload;
      state.errorUpdateBranchSettings = null;
    },
    setServerStatus(state, action: PayloadAction<ServerStatusPayload | null>) {
      state.serverStatus = action.payload;
    },
  },
});

export const settingsActions = settingsSlice.actions;
export default settingsSlice.reducer;
